export async function finalizeOrder(orderId: string) {
  const storeId = document.querySelector('meta[name="x-storeid"]')?.getAttribute('content');

  if (!storeId) {
    throw new Error('Store ID not found');
  }

  console.log('Finalizing order:', { orderId, storeId });

  try {
    const response = await fetch(`/umbraco/commerce/api/order/${orderId}/complete`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-storeid': storeId,
        Accept: 'application/json',
      },
    });

    console.log('Response status:', response.status);
    console.log('Response URL:', response.url);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error response:', errorText);
      throw new Error(`Network response was not ok: ${response.status}. Details: ${errorText}`);
    }

    if (response.status === 204) {
      console.log('Order successfully finalized (204 No Content response)');
      return { success: true };
    }

    const result = await response.json();
    console.log('Success response:', result);
    return result;
  } catch (error) {
    console.error('Error in finalizeOrder:', error);
    throw error;
  }
}
